export default __webpack_public_path__ + "61729445cecb8077503fabcafbb7c934.png";